import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminPartnerVenues = lazy(() => import("@/pages/admin/AdminPartnerVenues"));

export const Route = createFileRoute("/admin/partner-venues")({
  component: AdminPartnerVenues,
});
